import ApparelSizeSpecsPreview from '../../../../components/apparel-size-specs-preview/apparel-size-specs-preview.desktop';
import apparelSizeSpecsPreview from './apparel-size-specs-preview';

const configuredApparelSizeSpecsPreview = apparelSizeSpecsPreview(ApparelSizeSpecsPreview);
export default configuredApparelSizeSpecsPreview;
